import React from 'react';
import { useTranslation } from 'react-i18next';
import { BiEventType } from '@wix/da-bi/pkg/constants';
import { DeviationResourceType } from '../../types/deviation';
import GhostButton from '@wix/da-ds/pkg/Buttons/GhostButton';
var EditTierButton = function (_a) {
    var _b;
    var className = _a.className, onClick = _a.onClick, isOwner = _a.isOwner, tier = _a.tier, view = _a.view;
    var t = useTranslation().t;
    if (!isOwner) {
        return null;
    }
    return (React.createElement(GhostButton, { className: className, size: "medium", variant: "edit-purple", onClick: function (e) {
            e.stopPropagation();
            onClick();
        }, biData: {
            evid: BiEventType.TIER_EDIT_CLICK,
            typeid: DeviationResourceType.TIER,
            itemid: tier.deviationId,
            widgetname: view === 'promotion' ? 'tiers' : undefined,
        }, disabled: ['deleted', 'pending_deletion'].includes(((_b = tier.tier) === null || _b === void 0 ? void 0 : _b.state) || '') }, t('deviationview.tierCard.cta.edit')));
};
EditTierButton.displayName = 'EditTierButton';
export default EditTierButton;
//# sourceMappingURL=EditTierButton.js.map